import { toast } from "react-toastify";

export const getSelectedRowIds = (selectedRowIds) => {
  if (Array.isArray(selectedRowIds)) return selectedRowIds;
  if (selectedRowIds?.ids instanceof Set) return Array.from(selectedRowIds.ids);
  if (selectedRowIds instanceof Set) return Array.from(selectedRowIds);
  return [];
};

export const getSelectedExportRows = (rows = [], selectedRowIds, idField = "id") => {
  const ids = getSelectedRowIds(selectedRowIds);
  if (!ids.length) {
    toast.error("Please select at least one record");
    return null;
  }
  const idSet = new Set(ids.map(String));
  return rows.filter((row) => idSet.has(String(row?.[idField])));
};
